import React, { useDebugValue, useEffect, useState } from "react";

import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  
  Input,
  Button,
  Spinner,
  Badge,
} from "reactstrap";
import { MdModeEdit, MdDelete } from "react-icons/md";
// import { HiEye } from "react-icons/hi";
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import Swal from 'sweetalert2';
import AddCategoryModal from "./AddCategoryModel";
import { useDispatch } from "react-redux";

function CategoryList() {
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [categoryIdToDelete, setCategoryIdToDelete] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState(null);

  const [counting, setCounting] = useState([]);
  const pageSize = 10;
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [categoryPrevImage, setCategoryPrevImage] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [removedImages, setRemovedImages] = useState([]);

  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [videoLinks, setVideoLinks] = useState([""]);
  const [categoryImages, setCategoryImages] = useState([]);
  const [categoryIcon, setCategoryIcon] = useState(null);

  // const toggleModal = () => {
  //   setModalOpen(!modalOpen);
  //   if (modalOpen) {
  //     setSelectedCategory(null); // Reset selected category when closing the modal
  //   }
  // };

  const toggleModal = (isEditing = false) => {
    setModalOpen(!modalOpen);

    if (!modalOpen && !isEditing) {
      // Clear the form fields when opening the modal for adding a new category
      setSelectedCategory(null);
      setCategoryName("");
      setCategoryDescription("");
      setVideoLinks([""]);
      setCategoryImages([]);
      setCategoryPrevImage([])
      setSelectedImages([])
      setRemovedImages([])
      setCategoryIcon(null);
    }
  };

  const fetchCategories = async (pageNumber=currentPage, query = "") => {
    try {
      setLoader(true);
      const getAllCategories = await ApiClient.get(
        `api/category/get-category?page=${pageNumber}&limit=${pageSize}&searchText=${query}`,
        "",
        true,
        dispatch
      );
      setCategories(getAllCategories.body.result);
      setCounting(getAllCategories.body);
      setLoader(false);
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
      setLoader(false);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchCategories(currentPage, searchQuery);
  }, [currentPage, searchQuery]);

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleEditClick = (id) => {
    setSelectedCategory(id);
    toggleModal(true);
  };

  const handleAddClick = () => {
    toggleModal(false);
  };

  const confirmDelete = async () => {
    try {
      setLoader(true);
      const deleteCategory = await ApiClient.delete(
        `api/category/delete-category`,
        { id: categoryIdToDelete },
        true,
        dispatch
      );
      if (deleteCategory.status === true) {
        toast.success(deleteCategory.message, { autoClose: 1000 });
        setLoader(false);
        setShowDeleteAlert(false);
        fetchCategories(currentPage, searchQuery);
      }
    } catch (error) {
      setLoader(false);
      toast.error(error.message, { autoClose: 1000 });
      setShowDeleteAlert(false);
    }
  };

  const handleDelete = (id) => {
    setCategoryIdToDelete(id);
    setShowDeleteAlert(true);
  };

  const cancelDelete = () => {
    setShowDeleteAlert(false);
  };
  return (
    <>
      <div className="content">
      <div className="content-headline d-flex justify-content-between">
        <h4>Categories</h4>
      </div>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="5">
                  </Col>
                  <Col md="4">
                    <form>
                      <InputGroup className="no-border">
                        <Input
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                          <InputGroupText>
                            <i className="nc-icon nc-zoom-split" />
                          </InputGroupText>
                      </InputGroup>
                    </form>
                  </Col>
                  <Col md="3">
                    <Button
                      className="common-button mt-0"
                      onClick={handleAddClick}
                    >
                      Add Category
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {loader && (
                  <span className="table-loader">
                    <Spinner color="primary">Loading...</Spinner>
                  </span>
                )}
                {!loader && (
                  <>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Category Name</th>
                          <th>Description </th>
                          {/* <th>Email</th> */}
                          {/* <th>Status</th> */}
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {categories?.map((category) => (
                          <tr key={category._id}>
                            <td>{category?.categoryName}</td>
                            <td>{category?.categoryDescription}</td>
                            <td className="text-center">
                              <span
                                className="action-icon action-icon-yellow"
                                onClick={() => handleEditClick(category._id)}
                              >
                                <MdModeEdit />
                              </span>
                              <span
                                className="action-icon action-icon-red"
                                onClick={() => handleDelete(category._id)}
                              >
                                <MdDelete />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="pagination d-flex justify-content-center align-items-center">
                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        className="common-button"
                      >
                        Previous
                      </Button>
                      <span className="mx-3">
                        Page {counting?.currentPage} of {counting?.totalPages}
                      </span>
                      <span className="mx-3">
                        <strong>Total records: </strong>
                        {counting?.totalRecords}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === counting?.totalPages}
                        className="common-button"
                      >
                        Next
                      </Button>
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <AddCategoryModal
        isOpen={modalOpen}
        toggle={toggleModal}
        fetchCategories={fetchCategories}
        removedImages={removedImages}
        setRemovedImages={setRemovedImages}
        selectedImages={selectedImages}
        setSelectedImages={setSelectedImages}
        categoryPrevImage={categoryPrevImage}
        setCategoryPrevImage={setCategoryPrevImage}
        categoryId={selectedCategory}
        categoryName={categoryName}
        setCategoryName={setCategoryName}
        categoryDescription={categoryDescription}
        setCategoryDescription={setCategoryDescription}
        videoLinks={videoLinks}
        setVideoLinks={setVideoLinks}
        categoryImages={categoryImages}
        setCategoryImages={setCategoryImages}
        categoryIcon={categoryIcon}
        setCategoryIcon={setCategoryIcon}
      />

      {showDeleteAlert && (
        <Swal
          danger
          showCancel
          confirmBtnText="Yes, delete it!"
          confirmBtnBsStyle="danger"
          title="Are you sure?"
          onConfirm={confirmDelete}
          onCancel={cancelDelete}
          focusCancelBtn
        >
          You will not be able to recover this category!
        </Swal>
      )}
    </>
  );
}

export default CategoryList;
